import { render, staticRenderFns } from "./PlayCol.vue?vue&type=template&id=1e71fcc8&scoped=true"
import script from "./PlayCol.vue?vue&type=script&lang=js"
export * from "./PlayCol.vue?vue&type=script&lang=js"
import style0 from "./PlayCol.vue?vue&type=style&index=0&id=1e71fcc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e71fcc8",
  null
  
)

export default component.exports